'use client'
import { useEffect, useState } from 'react'
import { IconComponent } from '@/components/Icon/Icon'

/** Share links for a post. The URL is read after mount so server and client markup match. */
export const ShareSection = () => {
  const [url, setUrl] = useState('')
  useEffect(() => {
    setUrl(window.location.href)
  }, [])
  const u = encodeURIComponent(url)

  return (
    <div className="mx-auto mb-8 flex max-w-[750px] flex-col items-center gap-4">
      <p className="text-center text-lg font-semibold text-[#333]">Share this post</p>
      <div className="flex items-center gap-4">
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${u}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Share on Facebook"
        >
          <IconComponent icon="FaceBook" className="h-[30px] w-[30px]" />
        </a>
        <a
          href={`https://twitter.com/intent/tweet?url=${u}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Share on X"
        >
          <IconComponent icon="Twitter" className="h-[30px] w-[30px]" />
        </a>
        <a
          href={`https://pinterest.com/pin/create/button/?url=${u}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Share on Pinterest"
        >
          <IconComponent icon="Pinterest" className="h-[30px] w-[30px]" />
        </a>
        <a
          href={`https://www.linkedin.com/shareArticle?mini=true&url=${u}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Share on LinkedIn"
        >
          <IconComponent icon="LinkedIn" className="h-[30px] w-[30px]" />
        </a>
      </div>
    </div>
  )
}
